module.exports = __webpack_public_path__ + "media/img/frontend_application/content_production/other_service_three-c465f8295ce234d85ac1caac7ae0602a.png";